import $ from 'jquery';

import FormUtils from 'chairisher/util/form';
import PriceInputView from 'chairisher/view/offer/priceinput';

import zendeskWebWidgetInst from 'chairisher/component/zendesk';

import { CheckoutPosition } from 'chairisher/util/analytics';

/**
 * View with a form for recommending offer amounts.
 * Submitting the form leads the user to the make an offer page with the quantity/price prefilled.
 */
export default class RecommendedOffersView {
    constructor({ $el, productId, onSubmit }) {
        this.$el = $el;
        this.onSubmit = onSubmit;
        this.productId = productId;
    }

    bind() {
        this.priceInputView = new PriceInputView({
            $el: this.$el,
            formSelector: '#recommended-offers-form',
            onSubmit: this.onSubmit,
            productId: this.productId,
        });
        this.priceInputView.bind();

        const $recommendedOffers = this.$el.find('.js-recommended-offer');
        const removeSelection = () => $recommendedOffers.removeClass('selected js-selected');

        const $groupedInputs = this.$el.find('input.js-percent-input-group').add(this.getPriceInput());
        $groupedInputs.on('focus', () => removeSelection());

        $recommendedOffers.on('click', ({ currentTarget }) => {
            FormUtils.setFormGroupErrorMessage(this.$el.find('.js-form-group'), null);
            $groupedInputs.val('');
            removeSelection();
            $(currentTarget).addClass('selected js-selected');
        });

        this.$el.find('.js-contact-support-btn').on('click', () => {
            zendeskWebWidgetInst.setTrackingPosition(CheckoutPosition.MAO_MODAL);
            zendeskWebWidgetInst.handleWindowLoad();
        });
    }

    /**
     * @returns {jQuery}
     */
    getPriceInput() {
        return this.$el.find('input.js-price-input-group');
    }

    /**
     * Hides the recommended offer UI.
     */
    hide() {
        this.$el.modal('hide');
    }

    /**
     * Shows the recommended offer UI.
     *
     * @param {null|number} defaultPrice The default offer price value to show. The price input will be empty when null.
     */
    show(defaultPrice = null) {
        if (defaultPrice) {
            this.priceInputView.setDefaultPrice(defaultPrice);
        }
        this.$el.modal('show');
    }
}

/**
 * Binds the recommended offers view in a modal.
 * The user will be redirected to the offer/create page when the recommended offer form is submitted.
 *
 * @param {object} settings
 * @param {number} settings.productId
 * @param {jQuery} settings.$maoForm A form element that contains a "make an offer" cta
 * @param {jQuery} settings.$recommendedOfferModal The modal element
 * @param {Function=} settings.onModalShow Function that is called when modal is opened
 * @returns {RecommendedOffersView} The view, or null if the modal element doesn't exist on the page.
 */
export function bindMAORedirectModal({ productId, $maoForm, $recommendedOfferModal, onModalShow }) {
    let maoModal = null;
    if ($recommendedOfferModal.length > 0) {
        maoModal = new RecommendedOffersView({
            productId,
            $el: $recommendedOfferModal,
            onSubmit($form, params) {
                window.location.href = `${$form.attr('action')}?${params}`;
            },
        });
        maoModal.bind();

        $maoForm.find('button').on('click', (e) => {
            e.preventDefault();
            maoModal.show();
            if (onModalShow) {
                onModalShow();
            }
        });
    }

    return maoModal;
}
